import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ProcedureDiagram, ProcedureDiagramInput} from './procedure-diagram.model';

export const loadProcedureDiagrams = createAction(
  '[ProcedureDiagram/API] Load ProcedureDiagrams',
  props<{ procedureDiagrams: ProcedureDiagram[] }>()
);

export const addProcedureDiagram = createAction(
  '[ProcedureDiagram/API] Add ProcedureDiagram',
  props<{ procedureDiagram: ProcedureDiagram }>()
);

export const upsertProcedureDiagram = createAction(
  '[ProcedureDiagram/API] Upsert ProcedureDiagram',
  props<{ procedureDiagram: ProcedureDiagram }>()
);

export const addProcedureDiagrams = createAction(
  '[ProcedureDiagram/API] Add ProcedureDiagrams',
  props<{ procedureDiagrams: ProcedureDiagram[] }>()
);

export const upsertProcedureDiagrams = createAction(
  '[ProcedureDiagram/API] Upsert ProcedureDiagrams',
  props<{ procedureDiagrams: ProcedureDiagram[] }>()
);

export const updateProcedureDiagram = createAction(
  '[ProcedureDiagram/API] Update ProcedureDiagram',
  props<{ procedureDiagram: Update<ProcedureDiagram> }>()
);

export const updateProcedureDiagrams = createAction(
  '[ProcedureDiagram/API] Update ProcedureDiagrams',
  props<{ procedureDiagrams: Update<ProcedureDiagram>[] }>()
);

export const deleteProcedureDiagram = createAction(
  '[ProcedureDiagram/API] Delete ProcedureDiagram',
  props<{ id: string }>()
);

export const deleteProcedureDiagrams = createAction(
  '[ProcedureDiagram/API] Delete ProcedureDiagrams',
  props<{ ids: string[] }>()
);

export const clearProcedureDiagrams = createAction(
  '[ProcedureDiagram/API] Clear ProcedureDiagrams'
);

// CUSTOM
export const createProcedureDiagrams = createAction(
  '[ProcedureDiagram/API] create ProcedureDiagrams',
  props<{ input: ProcedureDiagramInput }>()
);


export const getProcedureDiagrams = createAction(
  '[ProcedureDiagram/API] get ProcedureDiagrams',
  props<{ serviceUniqueId: string }>()
);
